export default __webpack_public_path__ + "static/media/dk.99cbc127.svg";